module.exports = __webpack_public_path__ + "img/cloud.ea5537ed.png";